import React, { createContext, useContext, ReactNode } from 'react';
import { SegmentId } from '../../utils/segments';

interface DocumentContextType {
  selectedSegmentId: SegmentId;
}

const DocumentContext = createContext<DocumentContextType | undefined>(
  undefined
);

export const useDocumentContext = (): DocumentContextType => {
  const context = useContext(DocumentContext);
  if (!context) {
    throw new Error(
      'useDocumentContext must be used within a DocumentProvider'
    );
  }
  return context;
};

interface DocumentProviderProps {
  children: ReactNode;
  selectedSegmentId: SegmentId;
}

export const DocumentProvider: React.FC<DocumentProviderProps> = ({
  children,
  selectedSegmentId,
}) => {
  return (
    <DocumentContext.Provider value={{ selectedSegmentId }}>
      {children}
    </DocumentContext.Provider>
  );
};
